export default function userManagement() {
  const a = {}
  return { a }
}
